import { useState } from "react";
import { UserPlus, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function FollowBettorButton({ userId, name, size = "sm", onChange }) {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!userId || user?.user_id === userId) return null;
  const following = !!user?.following?.includes(userId);
  const toggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user) return navigate("/login", { state: { from: "/leaderboard" } });
    setBusy(true);
    try {
      const { data } = await api.post("/crew/follow", { user_id: userId });
      setUser((u) => ({ ...u, following: data.following }));
      onChange?.(data.is_following);
      toast.success(data.is_following ? `${data.name} added to your crew` : `${data.name} removed from your crew`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const cls = size === "lg" ? "gap-2 px-4 py-2 text-xs" : "gap-1 px-2 py-1 text-[10px]";
  return (
    <button data-testid="follow-bettor-btn" data-following={following} disabled={busy} onClick={toggle} title={following ? `Remove ${name} from your crew` : `Add ${name} to your crew`}
      className={`inline-flex shrink-0 items-center rounded-full border font-bold uppercase tracking-wider transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 ${cls} ${following ? "border-cyan-400/60 bg-cyan-400/15 text-cyan-200" : "border-[#26334D] text-slate-400 hover:border-cyan-400/60 hover:text-cyan-200"}`}>
      {following ? <UserCheck size={size === "lg" ? 14 : 11} /> : <UserPlus size={size === "lg" ? 14 : 11} />} {following ? "In crew" : "Follow"}
    </button>
  );
}
